const ALLOWED_CHARS_REGEX = /[^A-Za-z0-9!@#$%^&*()_+\-=?.,:'"£¢`\s]/g;

/**
 * What a card or insert text box keeps of typed text: the printable characters, at most `maxLength`
 * characters and `maxLines` lines.
 */
export function sanitiseVisualiserText(value: string, limits: { maxLength?: number; maxLines?: number }): string {
  const { maxLength, maxLines } = limits;
  let next = value.replace(ALLOWED_CHARS_REGEX, '');
  if (maxLength && next.length > maxLength) {
    next = next.slice(0, maxLength);
  }
  if (maxLines) {
    const lines = next.split('\n');
    if (lines.length > maxLines) {
      next = lines.slice(0, maxLines).join('\n');
    }
  }
  return next;
}
